import { setContext } from "@apollo/client/link/context";
import { isEmpty } from "lodash-es";

export const ROOM_ACCESS_TOKEN_HEADER = "X-IRD-Access-Code";

interface RoomAccessTokenContext {
  roomAccessToken?: string;
}

export const withRoomAccessToken = (
  roomAccessToken?: string,
): RoomAccessTokenContext => ({
  roomAccessToken,
});

export const roomAccessTokenLink = setContext(
  (
    _,
    {
      headers,
      roomAccessToken,
    }: RoomAccessTokenContext & { headers?: Record<string, string> },
  ) =>
    isEmpty(roomAccessToken)
      ? {}
      : {
          headers: { ...headers, [ROOM_ACCESS_TOKEN_HEADER]: roomAccessToken },
        },
);
